import { BlockStack, Card, Divider, Text } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';
import AppStatusContent from './app-status/AppStatus';
import CurrentPlan from './CurrentPlan';

const OtherInfoCard = () => {
    const { t } = useTranslation();

    return (
        <Card>
            <BlockStack gap={'300'}>
                <BlockStack gap={'150'}>
                    <Text as="p" variant="headingMd">
                        {t('DASHBOARD.APP_STATUS.TITLE')}
                    </Text>
                    <Text as="p" variant="bodyMd" tone="subdued">
                        {t('DASHBOARD.APP_STATUS.SUBTITLE')}
                    </Text>
                </BlockStack>
                <CurrentPlan />
                <Divider />
                <AppStatusContent />
            </BlockStack>
        </Card>
    );
};

export default OtherInfoCard;
